import { ensureBufferPolyfill } from '@/polyfills'

/** Shared thenable for the Reown/wagmi root so `use()` and idle/hover preload hit the same promise. */
let walletRootPromise = null

export function loadWalletRoot() {
  if (!walletRootPromise) {
    walletRootPromise = ensureBufferPolyfill()
      .then(() => import('./ReownWagmiRoot.jsx'))
      .then(mod => mod.default)
  }
  return walletRootPromise
}

export function preloadWalletRoot() {
  return loadWalletRoot()
}
